<template>
    <div class="container">
        <div class="feedback" v-for="item in feedbackList" :key="item.id">
            <div class="item">
                <div class="item-name">问题类型：</div>
                <div class="item-info">{{item.type}}</div>
            </div>
            <div class="item">
                <div class="item-name">反馈时间：</div>
                <div class="item-info">{{formatTime(item.upload_time*1000)}}</div>
            </div>
            <div class="item">
                <div class="item-name">详细说明：</div>
                <div class="item-info feedback-text">{{item.content}}</div>
            </div>
            <div class="details-box">
                <div class="details" @click="details(item.id)">查看详情</div>
            </div>            
        </div>        
    </div>
</template>
<script>
import {feedback_record} from '../api/my'
import moment from 'moment'
export default {
    data() {
        return {
            imei:'',
            feedbackList:[],
        };
    },
    computed: {},
    methods: {
        details(id){
            this.$router.push({ path: '/feedback-details', query: { id: id}})
        },
        feedbackRecord(){
            feedback_record(this.imei).then(res=>{
                if(res.status==200){
                    this.feedbackList=res.data.feedbackData
                }
            })
        },
        formatTime(time){
            return moment(time).format("YYYY年MM月DD日 HH:mm")
        }
    },
    created() {
        let imei=localStorage.getItem('imei');
        this.imei=imei;
        this.feedbackRecord()
    },
};
</script>
<style lang='less' scoped>
.container{
    padding: 16px;
}
.feedback{
    background-color: #fff;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
}
.item{
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.item-name{
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    width: 25%;
}
.item-info{
    height: 14px;
    line-height: 14px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
}
.feedback-text{
    width: 70%;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: right;
}
.details-box{
    height: 32px;
    margin-top: 15px;
}
.details{
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    border-radius: 16px;
    background-color: #01D6D6;
    width: 100px;
    float: right;
}
</style>